<template>
    <TemplateClient :subtitle="$t('client.gift_card.title')">

        <p>Contenu en cours de développement</p>

    </TemplateClient>
</template>

<script>
import TemplateClient from '@/components/templates/TemplateClient';
import { mapState } from 'vuex';

export default {
    name: 'ClientGiftCard',
    components: {TemplateClient},
    computed: {
        ...mapState(['client'])
    }
}
</script>
